module.exports = __webpack_public_path__ + "img/undraw_cms_re_asu0.11a3e1b7.svg";